import { useState } from "react";
import { Box, TextField, Button, Link } from "@mui/material";
import { Grid } from "@mui/system";
import "./Login.css";
import "../../common/Common.css";
import { customButtonStyles } from "../../common/commonStyles";
import { useNavigate } from "react-router-dom";
import logo from "../../assets/logo.svg";
import ReusableSnackbar from "../../shared/Alert/ReusableSnackbar";
import { login } from "../../services/authservice";

const LoginPage = () => {
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });
  const [snackbarOpen, setSnackbarOpen] = useState({
    status: false,
    message: "",
    severity: "",
  });
  const navigate = useNavigate();
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };
  const handleClose = () => setSnackbarOpen(false);

  const handleLogin = async () => {
    const { email, password } = formData;
    try {
      const response = await login(email, password);
      if (response.success) {
        setFormData({ email: "", password: "" });
        navigate("/home");
      }
    } catch (error) {
      if (error.response && error.response.status === 400) {
        setSnackbarOpen({
          status: true,
          message: error.response.data.detail,
          severity: "error",
        });
      } else {
        setSnackbarOpen({
          status: true,
          message: "Something went wrong. Please try again later.",
          severity: "error",
        });
      }
    }
  };

  return (
    <>
      <Box
        sx={{
          minHeight: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Box
          sx={{ width: "100%", maxWidth: 400, mx: "auto" }}
          className="login-box"
        >
          <Box sx={{ textAlign: "center", mb: 2 }}>
            <img src={logo} alt="Logo" style={{ height: 30, maxHeight: 30 }} />
          </Box>
          <Box>
            <h3 className="login-text">Hello! let's get started</h3>
            <h5 className="login_subtext">Sign in to continue.</h5>
          </Box>
          <TextField
            required
            fullWidth
            label="Email address"
            name="email"
            id="fullWidth"
            margin="normal"
            value={formData.email}
            onChange={handleInputChange}
            autoComplete="off"
            className="custom-textfield"
          />

          <TextField
            id="outlined-password-input"
            label="Password"
            type="password"
            autoComplete="current-password"
            required
            fullWidth
            name="password"
            value={formData.password}
            onChange={handleInputChange}
            margin="normal"
            className="custom-textfield"
          />
          <Button
            variant="contained"
            fullWidth
            sx={customButtonStyles}
            onClick={handleLogin}
          >
            Sign In
          </Button>
          <Grid container spacing={2}>
            <Grid size={12}>
              <Link href="/forgotPassword" className="forgot-password">
                Forgot password ?
              </Link>
            </Grid>
            <Grid size={12} className="create_account">
              Don't have an account?{" "}
              <Link href="/registration" underline="none">
                Sign Up
              </Link>
            </Grid>
          </Grid>
        </Box>
      </Box>
      <ReusableSnackbar
        open={snackbarOpen.status}
        message={snackbarOpen.message}
        onClose={handleClose}
        severity={snackbarOpen.severity}
      />
    </>
  );
};

export default LoginPage;
